export default __webpack_public_path__ + "media/images/svg/product-list.svg";